import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "List Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M2.56 36.332a9.65 9.65 0 0 1 9.65-9.649h212.282c7.428 0 12.07 8.041 8.357 14.474a9.65 9.65 0 0 1-8.357 4.824H12.21c-5.33 0-9.649-4.32-9.649-9.649m9.65 86.843h212.282c7.428 0 12.07-8.041 8.357-14.474a9.65 9.65 0 0 0-8.357-4.824H12.21c-7.428 0-12.07 8.041-8.356 14.474a9.65 9.65 0 0 0 8.356 4.824m212.282 57.896H12.21c-7.428 0-12.07 8.041-8.356 14.474a9.65 9.65 0 0 0 8.356 4.824h212.283c7.428 0 12.07-8.04 8.357-14.474a9.65 9.65 0 0 0-8.357-4.824" }, null, -1)
  ]))]))
}
export default { render: render }